import { on } from '@ember/modifier';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import type { Dayjs } from 'dayjs';
import { t } from 'ember-intl';
import { not } from 'ember-truth-helpers';
import dateRangeDisplay from 'lumen/utils/dates/date-range-display';

import styles from './trigger-target.module.css';

interface HotelNetRevenueDatepickersComparisonPickerTriggerTargetSignature {
  Args: {
    isOpen: boolean;
    selected:
      | string
      | {
          end: Dayjs;
          start: Dayjs;
        };
    toggleDropdown: () => void;
  };
}

export default class HotelNetRevenueDatepickersComparisonPickerTriggerTarget extends Component<HotelNetRevenueDatepickersComparisonPickerTriggerTargetSignature> {
  @service declare intl: Services['intl'];

  get formattedSelected(): string {
    if (
      typeof this.args.selected === 'object' &&
      'start' in this.args.selected
    ) {
      return dateRangeDisplay(
        this.args.selected.start,
        this.args.selected.end,
        this.intl,
      );
    }

    return this.intl.t(this.args.selected);
  }

  <template>
    {{! template-lint-disable require-presentational-children }}
    <div
      class="prism-dropdown-trigger
        {{styles.trigger}}
        {{if @isOpen styles.trigger-open}}"
      data-event-id="net-revenue-comparison-trigger-toggle"
      data-event-value={{not @isOpen}}
      data-test-id="net-revenue-comparison-trigger"
      role="button"
      {{on "click" @toggleDropdown}}
    >
      <div class="{{styles.trigger-content}} gap-100">
        <span>
          {{t "net_revenue.vs"}}
          {{this.formattedSelected}}
        </span>
        <PrismIcon
          @name={{if @isOpen "chevron-up" "chevron-down"}}
          @size="small"
        />
      </div>
    </div>
  </template>
}
